export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20fashion%20and%20lifestyle%20products%20including%20sneakers%2C%20watches%2C%20bags%2C%20sunglasses%2C%20and%20accessories%20floating%20in%20a%20dreamy%20gradient%20arrangement%20with%20soft%20coral%20peach%20and%20warm%20cream%20tones%2C%20ethereal%20lighting%2C%20modern%20editorial%20style%2C%20gentle%20shadows%2C%20sophisticated%20luxury%20product%20display%2C%20highly%20detailed%20artistic%20photography&width=1600&height=900&seq=hero-vigorbuy-v2&orientation=landscape"
          alt="Vigorbuy Spreadsheet product discovery hub featuring curated fashion and accessory collections"
          title="Vigorbuy Spreadsheet - Product Discovery Hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
      </div>

      <div className="relative w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full border border-background-50/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-xs font-medium text-background-50">Updated Daily</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
            Vigorbuy Spreadsheet
            <br />
            <span className="text-background-50/80 font-normal">The Largest Product Discovery Hub</span>
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-50/80 leading-relaxed max-w-lg">
            Discover the best Vigorbuy Spreadsheet collections, trending products, trusted guides, and shopping tutorials — all in one place.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              vigorbuy sheet
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-foreground-950 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-shopping-bag-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#about" className="text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}